import { EntryField } from '../util/common/entryField';
import { RepairItemHeaderField } from './repairItemHeaderField';
import { RepairItemSelectCard } from './repairItemSelectCard';
import { InsuranceResultInfoType, RepairItemType } from '@/types/bodyAndPaint';

interface RepairItemSelectEntryFieldProps {
  list: RepairItemType[];
  onCheckImage: () => void;
  isInsurance: boolean;
  insurance: InsuranceResultInfoType;
  onChange: ({ index, select }: { index: number; select: number }) => void;
}
export const RepairItemSelectEntryField = ({
  list,
  onChange,
  isInsurance,
  insurance,
  onCheckImage,
}: RepairItemSelectEntryFieldProps) => {
  return (
    <div className={'repair-item-select-entry-field'}>
      <RepairItemHeaderField
        onCheckImage={onCheckImage}
        isInsurance={isInsurance}
        insurance={insurance}
      />
      <EntryField label={'整備する項目を選択してください'} required={false}>
        <div className={'repair-item-select-list'}>
          {list.map((infoItem, index) => (
            <RepairItemSelectCard
              key={index}
              itemIndex={index}
              info={infoItem}
              onChange={(select: number) => onChange({ select, index })}
            />
          ))}
        </div>
      </EntryField>
    </div>
  );
};
